import { useContext } from 'react';
import { LoadingContext } from '../context/LoadingContext';

export function useLoadingGlobal() {
  const context = useContext(LoadingContext);
  return context;
}
